import { render, staticRenderFns } from "./LabelEditor.vue?vue&type=template&id=2a86f568&scoped=true&"
import script from "./LabelEditor.vue?vue&type=script&lang=js&"
export * from "./LabelEditor.vue?vue&type=script&lang=js&"
import style0 from "./LabelEditor.vue?vue&type=style&index=0&id=2a86f568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86f568",
  null
  
)

export default component.exports